import * as React from "react";
import { Config } from "./context";
import { format } from "date-fns";
import { WithTooltip, Tag } from "@hubper/core-ui/components";

type Renderer = Config["render"];

type TagType = {
  id: string;
  name: string;
};

// @ts-ignore
export const tags: Renderer = ({ value, width, row }: any) => {
  // store index of tag that does not fit into cell
  const [skipFromIndex, setSkipFromIndex] = React.useState(-1);

  const tagRefs = React.useRef<Record<string, HTMLElement>>({});

  const tagStyle: React.CSSProperties = { margin: 0, marginRight: 6 };

  React.useLayoutEffect(() => {
    const tags = Object.keys(tagRefs.current)
      .map(id => tagRefs.current[id])
      .filter(Boolean);

    // skip if there are no tagRefs
    if (!tags || tags.length === 0) {
      return;
    }

    const tagOutside = tags.findIndex(
      tag => tag.offsetLeft + tag.offsetWidth + 75 > width
    );

    setSkipFromIndex(tagOutside);
  }, [value, width]);

  // by default, render all tags
  if (skipFromIndex === -1) {
    return (!value || !Array.isArray(value) ? [] : value).map(tag => (
      <Tag
        ref={x => (tagRefs.current[tag.id] = x as any)}
        key={tag.id}
        text={tag.name}
        style={tagStyle}
      />
    ));
  }

  const rest = value.slice(skipFromIndex);

  return value
    .slice(0, skipFromIndex)
    .map((item: TagType) => (
      <Tag text={item.name} key={item.id} style={tagStyle} />
    ))
    .concat(
      <WithTooltip
        key="rest"
        content={rest.map((tag: TagType) => tag.name).join(", ")}
      >
        <Tag text={`+${rest.length}`} style={tagStyle} />
      </WithTooltip>
    );
};

export const date: Renderer = ({ value }) =>
  value ? format(value, "DD-MM-YYYY") : "";
